import { render, staticRenderFns } from "./TableCrud.vue?vue&type=template&id=4553853c"
import script from "./TableCrud.vue?vue&type=script&lang=js"
export * from "./TableCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports